// File: src/components/location/AddLocationModal.js
import React, { useState } from "react";
import { Modal, Button, Form, Spinner, Alert, Row, Col } from "react-bootstrap";
import axios from "axios";
import { US_STATES, COUNTRIES } from "../constants/locales"; // adjust the import paths as needed

function AddLocationModal({ show, handleClose, onLocationAdded, seasonId }) {
    const [formData, setFormData] = useState({
        name: "",
        street_1: "",
        street_2: "",
        city: "",
        state: "",
        postcode: "",
        country: "",
    });

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        axios
            .post(`/api/leagues/add-location/${seasonId}/`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                onLocationAdded(response.data);
                setFormData({
                    name: "",
                    street_1: "",
                    street_2: "",
                    city: "",
                    state: "",
                    postcode: "",
                    country: "",
                });
                handleClose();
            })
            .catch((error) => {
                console.error("Error adding location:", error);
                if (error.response && error.response.data) {
                    setErrorMessage(error.response.data.detail || "Failed to add location.");
                } else {
                    setErrorMessage("An unexpected error occurred.");
                }
            })
            .finally(() => setLoading(false));
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Field</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="name">
                                <Form.Label>Location Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="street_1">
                                <Form.Label>Street 1</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="street_1"
                                    value={formData.street_1}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="street_2">
                                <Form.Label>Street 2</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="street_2"
                                    value={formData.street_2}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Form.Group controlId="city">
                                <Form.Label>City</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="state">
                                <Form.Label>State</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a state</option>
                                    {US_STATES.map(([code, label]) => (
                                        <option key={code} value={code}>
                                            {label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="postcode">
                                <Form.Label>Post/Zip-code</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="postcode"
                                    value={formData.postcode}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="country">
                                <Form.Label>Country</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a country</option>
                                    {COUNTRIES.map(([code, label]) => (
                                        <option key={code} value={code}>
                                            {label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="text-end">
                        <Button variant="secondary" onClick={handleClose} className="me-2">
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm" /> : "Add Location"}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default AddLocationModal;
